import { useState, useEffect } from "react";
import { useKnowledgeBaseOverview } from "../contexts/KnowledgeBaseOverviewContext";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import NewKnowledgeDocumentCard from "../components/NewKnowledgeDocument";
import ExistingKnowledgeDocumentCard from "../components/ExistingKnowledgeDocument";
import CircularProgress from "@mui/material/CircularProgress";
import PageSelect from "../components/PageSelect";

function KnowledgeBaseOverview() {
  const { loading, pageNumber, allSummaries } = useKnowledgeBaseOverview();
  const [displayedCards, setDisplayedCards] = useState([]);

  useEffect(() => {
    if (!loading) {
      if (pageNumber === 1) {
        setDisplayedCards([
          <NewKnowledgeDocumentCard key={0} />,
          ...allSummaries
            .slice(0, 5)
            .map((knowledgeDocument, index) => (
              <ExistingKnowledgeDocumentCard
                key={index + 1}
                knowledgeDocument={knowledgeDocument}
              />
            )),
        ]);
      } else {
        const startIndex = (pageNumber - 1) * 6;
        const endIndex = startIndex + 6;
        setDisplayedCards(
          allSummaries
            .slice(startIndex, endIndex)
            .map((knowledgeDocument, index) => (
              <ExistingKnowledgeDocumentCard key={index} knowledgeDocument={knowledgeDocument} />
            ))
        );
      }
    }
  }, [loading, pageNumber, allSummaries]);

  return (
    <MKBox component="section" py={3} mt={12}>
      <Container>
        <Grid container item xs={12} lg={8}>
          <MKTypography variant="h3">Kennisbank</MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="text">
            Met deze drie-staps-flow kun je in het beheerpaneel per agent aparte instructies
            aanpassen en zo precies bepalen hoe elk onderdeel reageert.
          </MKTypography>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          spacing={{ xs: 0, lg: 3 }}
          sx={{ pt: 2, pb: 3, px: 2, mx: "auto" }}
        >
          <PageSelect />
        </Grid>
        <Grid container spacing={3} sx={{ mt: 3 }}>
          {loading ? (
            <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
              <MKBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="400px"
              >
                <CircularProgress size={40} />
              </MKBox>
            </Grid>
          ) : (
            <>
              {displayedCards.length > 0 ? (
                displayedCards.map((card, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <MKBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                      {card}
                    </MKBox>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12} display="flex" justifyContent="center">
                  <MKBox py={3}>
                    <NewKnowledgeDocumentCard />
                  </MKBox>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default KnowledgeBaseOverview;
